/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ViewsInputs */

const en_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Views`)
};

const de_views = /** @type {(inputs: ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufe`)
};

/**
* | output |
* | --- |
* | "Views" |
*
* @param {ViewsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views = /** @type {((inputs?: ViewsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ViewsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_views(inputs)
	return de_views(inputs)
});